import { encodedStringParser, numberParser } from '../inboundParsers';
function incomeEventTypeParser(str) {
    return str;
}
export const SHOW_INCOME_EVENT_PAYLOAD_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [
        { name: 'incomeEventId', parser: numberParser },
        { name: 'fromPlayerId', parser: numberParser },
        { name: 'incomeAmount', parser: numberParser },
        { name: 'incomeEventType', parser: incomeEventTypeParser },
        { name: 'message', parser: encodedStringParser }
    ]
};
